import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  visible: PropTypes.bool.isRequired,
}

const Loader = ({ visible }) => (
  visible ? (
    <div className="uk-section">
      <div className="uk-container">
        <div className="uk-text-center">
          <div data-uk-spinner="" />
        </div>
      </div>
    </div>
  ) : (
    <div />
  )
)

Loader.propTypes = propTypes

export default Loader
